import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';

@Component({
  selector: 'app-carga-actualizacion-capitulos',
  templateUrl: './carga-actualizacion-capitulos.component.html',
  styleUrls: ['./carga-actualizacion-capitulos.component.css']
})
export class CargaActualizacionCapitulosComponent implements OnInit {

  @ViewChild('fileInput') fileInput: ElementRef;
  fileAttr = 'Seleccione un archivo';
  file: File | null;
  messageDialog: string = '';
  resultDialog: string = '';

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private requestParam: string;

  constructor(
    private helperClassService: HelperClassService,
    private router: Router,
    private apiCallService: ApiCallService
  ) { }

  ngOnInit() {
  }

  actualizarBDCapitulosForm = new FormGroup({
    nombreArchivo: new FormControl('', [Validators.required, Validators.minLength(4), Validators.pattern(Constanst.REGEXP_NOMBRE_ARCHIVO)])
  });

  onSubmit() {
    if (this.actualizarBDCapitulosForm.invalid) {
      return;
    } else {
      return this.confirm();
    }
  }

  confirm() {
    let fileName = this.actualizarBDCapitulosForm.controls['nombreArchivo'].value;
    let fileExtension = fileName != null ? fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length) : '';

    if (fileExtension.toLowerCase() == "mdb" || fileExtension.toLowerCase() == "accdb") {
      const dialogConfirmBD = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_BDFILE, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
      dialogConfirmBD.afterClosed().subscribe((result: string) => {

        if (result === Constanst.DIALOG_RESULT_ACTION) {
          this.requestParam = '?fileName='.concat((fileName != null ? fileName : ''));
          this.route = '/validateIfExistFile'.concat(this.requestParam);
          this.method = 'POST';

          this.apiCallService.call$(null, this.route, this.method, true, '', true).pipe(takeUntil(this.destroy$)).subscribe(
            response => {
              if (response.data.code === 'MSG-007') {//Existe archivo
                this.route = '/importBdFromChapter'.concat(this.requestParam);
                this.method = 'POST';
                this.apiCallService.call$(null, this.route, this.method, true, '', false).pipe(takeUntil(this.destroy$)).subscribe();
                this.messageDialog = Constanst.MSG_BDFILE_LOADED;
                this.resultDialog = Constanst.DIALOG_RESULT_SUCCESS;
              } else {
                switch (response.data.code) {
                  case 'MSG-008': {
                    this.messageDialog = Constanst.MSG_008;
                    break;
                  } case 'MSG-014': {
                    this.messageDialog = Constanst.MSG_014;
                    break;
                  } default: {
                    this.messageDialog = Constanst.MSG_GENERIC_ERROR;
                    break;
                  }
                }
                this.resultDialog = Constanst.DIALOG_RESULT_ERROR;
              }

              this.apiCallService.hideSpinner();
              const dialogError = this.helperClassService.openDialogGeneric('25rem', true, this.messageDialog, false, true, false, '', '', '', this.resultDialog);
              dialogError.afterClosed().subscribe(() => {
                this.router.navigate(['presupuestos']);
              });

            }, error => {
              this.apiCallService.hideSpinner();
              this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              this.router.navigate(['presupuestos']);
            });

        } else {
          dialogConfirmBD.close(false);
        }
      });
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_BDFILE_NOTYPE, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  navigateMenu(tag: string) {
    this.router.navigate(['/' + tag]);
  }
}
